import styled, { css } from 'styled-components'
import InternalLink from '../InternalLink'

const Button = styled.button`
  background: var(--white);
  border: 1px solid var(--dark-gray);
  padding: 7px 20px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 12px;
  color: var(--dark-gray);

  &:hover {
    color: var(--dark-gray);
    text-decoration: none;
  }

  &:focus {
    outline: none;
  }
  &:active {
    box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  }
  ${(props) =>
    props.primary &&
    css`
      background-color: var(--main-color);
      border-color: var(--main-color);
      color: var(--white);

      &:hover {
        color: var(--white);
      }
    `}
`
export const ButtonLink = Button.withComponent(InternalLink)
export default Button
